module.exports = __webpack_public_path__ + "img/1280x720-Technology.86ab34a3.jpg";